import { render, staticRenderFns } from "./TankManufacturers.vue?vue&type=template&id=09eda002"
import script from "./TankManufacturers.vue?vue&type=script&lang=js"
export * from "./TankManufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports